module.exports = __webpack_public_path__ + "static/media/nf.5ab0b85f.svg";